import { render, staticRenderFns } from "./ChooseScenario.vue?vue&type=template&id=9c7e7f4a&scoped=true&"
import script from "./ChooseScenario.vue?vue&type=script&lang=ts&"
export * from "./ChooseScenario.vue?vue&type=script&lang=ts&"
import style0 from "./ChooseScenario.vue?vue&type=style&index=0&id=9c7e7f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7e7f4a",
  null
  
)

export default component.exports